// src/Logout.js
import './asset/App.css';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Result = () => {
    const navigate = useNavigate();

    fetch('https://macct.tw/api/logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'credentials': 'include'
        },
        body: JSON.stringify({}),
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if(data.success){
          alert("登出成功");
          navigate('/login');
        }else{
          alert("登出失敗，請再試一次");
        }
      })
      .catch(error => {
        console.error('Error:', error);
    });


    return (
        <div className="App">
        </div>
    );
};

export default Result;